// src/App.js
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import Header from "../src/components/Header";
import Reports from "../src/components/Report";
import Home from "./components/Home";
import Footer from "./components/Footer";
import GoogleSheetUtil from "./components/Utils/GoogleSheetUtil";
import CrudCategoryPage from "./CrudCategoryPage";
import CrudPage from "./CrudPage";
import { useSelector } from "react-redux";

function App() {
  
  const routeTree = useSelector((state) => {
    return state.route;
  });
  // console.log(crudJson);
  return (
    <Router>
      <Header/>
      { routeTree.route? 
      <Routes>
        {/* Default redirect to Production */}
        {/* <Route path="/" element={<Navigate to="/production" />} /> */}
        <Route path="/" element={<Home />} />
        
        { routeTree.route.category.map ((category, idx) => (
            <Route path={category.rootPath} 
            element={<CrudCategoryPage key={category.rootPath} item={category.item} 
              rootPath={category.rootPath} rootDefaultPath={category.rootDefaultPath} />}>  
            {
              category.item.map((item, idx) => (
                <>
                {
                  idx === 0? <Route
                  index
                  element={<CrudPage key={item.entity} title={item.title} subTitle={item.subTitle} 
                  entity={item.entity} allColumns={item.columns} />} 
                />: <></>
                }
                <Route path={item.entity} element={<CrudPage key={item.entity} title={item.title} subTitle={item.subTitle} 
                    entity={item.entity} allColumns={item.columns} />} />
                </>
              )
            )
            }
            </Route>
          )
        )}
        <Route path="/reports" element={<Reports />} >
          <Route index element={<GoogleSheetUtil />} />
          <Route path="googlesheet" element={<GoogleSheetUtil />} />
        </Route>
      </Routes> :
      <Routes>
<Route path="/" element={<Home />} />
      </Routes>
}
      <Footer />
    </Router>
  );
}

export default App;
